import { Flex } from 'antd';
import React from 'react';
import styled from 'styled-components';

const DescriptionItemLabel = styled.div`
  font-size: 14px;
  color: ${props => props.theme.colorTextSecondary};
`;
const DescriptionItemValue = styled.div`
  font-size: 16px;
  color: ${props => props.theme.colorText};
`;

export interface IDescriptionItemProps {
  value?: React.ReactNode;
  label: string;
}

/**
 * ...
 */
export function DescriptionItem(props: IDescriptionItemProps) {
  const { label, value } = props;
  if (!label) return null;

  return (
    <Flex vertical>
      <DescriptionItemLabel>{label}</DescriptionItemLabel>
      <DescriptionItemValue>{value}</DescriptionItemValue>
    </Flex>
  );
}
